<script setup>
import WishBtn from "@/components/three-in-one/toshiba/product/wish-btn/v1/Index.vue";

import { ref, defineProps, onMounted, defineEmits } from "vue";
import { getJumpLink } from "@/utils/common.js";
// import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
import { isPhonePortrait } from "@/hooks/common/useUtils";

// const { plpContentSource } = shopifyConst;

const $emit = defineEmits(["shopNow"]);
const props = defineProps({
  stateKey: {
    type: String,
    default: ''
  },
  target: {
    type: String,
    default: '_self'
  },
  product: {
    type: Object,
    default: null
  },
  buttonName: {
    type: String,
    default: ''
  },
  currentIndex: {
    type: Number,
    default: 0
  },
});

const productItem = ref({});
// const discountRateNum = ref('50');

const mainImg = ref({}); // 产品的主图像信息

onMounted(() => {
  productItem.value = { ...props.product, ...props.product?.product };
  mainImg.value = getMainImg(productItem.value); // 获取产品的主图像信息
})

/**
 * 获取产品的主图像信息。
 * @param {Object} product - 产品信息对象。
 * @returns {Object} 包含主图像 URL 和替代文本的对象。
 */
const getMainImg = (product) => {
  const imgUrl = product?.mainImage || product?.[!isPhonePortrait ? 'images' : 'imageMobile']?.[0];
  const altText = product?.altText || product?.[!isPhonePortrait ? 'imagesAltTexts' : 'imageMobilesAltTexts']?.[0];
  return { imgUrl, altText };
}

const clickShopNow = (product, event) => {
  if (!event.target.closest('*[jumpable]')) { // 没有可跳转属性标识不跳转
    return;
  }

  $emit('shopNow', {
    item_id: product?.productModelNumber,
    item_name: product?.productName
  });
  
  const a = document.createElement('a');
  a.href = getJumpLink(product?.link);
  a.target = props.target;
  a.click();
}

</script>

<template>
  <div @click="clickShopNow(productItem, $event)" class="csr-product-v3__item">
    <div>
      <div class="csr-product-v3__top">
        <div class="csr-product-v3__tag-discount-box">
          <div v-if="productItem?.productTag && productItem?.displayProductTag" class="csr-product-v3__item__tag">
            <span class="csr-product-v3__item__tag-text">{{ productItem?.productTag }}</span>
          </div>
          <!-- <div class="csr-product-v3__discount" v-if="discountRateNum">
            <i class="csr-product-v3__discount__icon"></i>
            <span>{{ discountRateNum }}%</span>
          </div> -->
        </div>
        <div class="csr-product-v3__wish-badges-box">
          <WishBtn
            :current-index="currentIndex"
            :product-model="productItem?.productModelNumber"
            :product-name="productItem?.productName"
            :shopify-id="productItem?.shopifyId"
            :sku-info="productItem"
            :shopify-variant="{}"
          />
          <div class="csr-product-v3__item__badges">
            <template v-for="(src, index) in productItem?.badges">
              <img v-if="index < 5" :src="src" art="" :key="`badges${index}`" class="csr-product-v3__item__badges-icon" />
            </template>
          </div>
        </div>
        <div jumpable class="csr-product-v3__image">
          <img :src="mainImg.imgUrl" :alt="mainImg?.altText || productItem?.productName" />
        </div>
        <div jumpable class="csr-product-v3__model">{{ productItem?.productModelNumber }}</div>
        <div jumpable class="csr-product-v3__name">{{ productItem?.productName }}</div>
      </div>
      <ul jumpable v-if="productItem?.bulletPoints?.length > 0" class="csr-product-v3__msg">
        <li v-for="(item, index) in productItem?.bulletPoints.slice(0, 3)" :key="'bulletPoints' + index" class="csr-product-v3__content">
          <span class="csr-product-v3__content-txt">{{ item }}</span>
        </li>
      </ul>
      <ul jumpable v-else-if="productItem?.productDescription?.length > 0" class="csr-product-v3__msg">
        <li v-for="(item, index) in productItem?.productDescription.slice(0, 3)" :key="'description' + index" class="csr-product-v3__content">
          <!-- <span class="csr-product-v3__content-txt">{{ plpContentSource === 'title' ? item?.title : item?.description }}</span> -->
          <span class="csr-product-v3__content-txt">{{ item.description }}</span>
        </li>
      </ul>
    </div>
    
    <div class="csr-product-v3__bottom">
      <a jumpable class="csr-product-v3__btn">{{ buttonName }}</a>
    </div>
  </div>
</template>
